import React, { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ChangePasswordModal from "./ChangePasswordModal";

const LockPersonIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <rect x="15" y="11" width="7" height="6" rx="1" />
        <path d="M17 11V9a2.5 2.5 0 0 1 5 0v2" />
    </svg>
);

const ExitLogoutIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
);

export const MenuList = (props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [openPasswordModal, setOpenPasswordModal] = useState(false);

    const { anchorEl, open, onClose, onClick, ...other } = props;

    const handleOpenPasswordModal = () => {
        if (onClose) onClose();
        setOpenPasswordModal(true);
    };

    const handleLogout = () => {
        if (onClose) onClose();
        localStorage.removeItem("user");
        localStorage.removeItem("profile");
        localStorage.removeItem("data");
        navigate("/");
    };

    return (
        <>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={onClose}
                onClick={onClick}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: "visible",
                        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.12)",
                        borderRadius: "16px",
                        mt: 1.5,
                        p: 1,
                        minWidth: 200,
                        "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 20,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0
                        }
                    }
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                {...other}
            >
                <MenuItem
                    onClick={handleOpenPasswordModal}
                    sx={{
                        borderRadius: "12px",
                        py: 1.2,
                        px: 1.8,
                        my: 0.4,
                        display: "flex",
                        alignItems: "center",
                        gap: 1.8,
                        "&:hover": {
                            backgroundColor: "rgba(239, 68, 68, 0.06)"
                        }
                    }}
                >
                    <Box
                        sx={{
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            backgroundColor: "#fee2e2",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0
                        }}
                    >
                        <LockPersonIcon />
                    </Box>
                    <Typography variant="body2" sx={{ fontWeight: 600, fontSize: "14px", color: "#1f2937" }}>
                        {t("change_password") || "Đổi mật khẩu"}
                    </Typography>
                </MenuItem>

                <MenuItem
                    onClick={handleLogout}
                    sx={{
                        borderRadius: "12px",
                        py: 1.2,
                        px: 1.8,
                        my: 0.4,
                        display: "flex",
                        alignItems: "center",
                        gap: 1.8,
                        "&:hover": {
                            backgroundColor: "rgba(34, 197, 94, 0.06)"
                        }
                    }}
                >
                    <Box
                        sx={{
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            backgroundColor: "#dcfce7",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0
                        }}
                    >
                        <ExitLogoutIcon />
                    </Box>
                    <Typography variant="body2" sx={{ fontWeight: 600, fontSize: "14px", color: "#1f2937" }}>
                        {t("logout") || "Đăng xuất"}
                    </Typography>
                </MenuItem>
            </Menu>

            <ChangePasswordModal
                open={openPasswordModal}
                onClose={() => setOpenPasswordModal(false)}
            />
        </>
    );
};

export default MenuList;
